module.exports = __webpack_public_path__ + "static/img/whatsapp-optin.c0b156d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/whatsapp-optin.jpg
// module id = q/g4
// module chunks = 6